export default "__VITE_ASSET__0j0Hiv1Q__"